import React from 'react';

import { FaTimesCircle } from 'react-icons/fa';

import LogoFaded from 'modules/partial/components/LogoFaded';

function TokenExpired() {
  return (
    <>
      <LogoFaded />
      <div className="h-screen flex">
        <div className="m-auto space-y-8 flex flex-col">
          <div className="h-24 w-24 bg-primary-500 rounded-full flex m-auto">
            <FaTimesCircle className="h-12 w-12 m-auto text-white" />
          </div>

          <div className="space-y-3 text-center">
            <div className="font-semibold text-2xl">Token has Expired</div>
            <div className="text-gray-500 text-sm animate-pulse">
              REDIRECTING...
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

TokenExpired.propTypes = {};

export default TokenExpired;
